import { dataLayerProductClick } from '../../../../lib/analytics/datalayer'

export const playerDataLayerProductClick = (contentItem, position, header) => {
  dataLayerProductClick(contentItem, position, `${header} (in-player)`)
}
